import React from 'react';
import * as PropTypes from 'prop-types';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import {
  ThemeProvider as MuiThemeProvider,
  StyledEngineProvider
} from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

import MuiTheme from './materialUiTheme';
import GlobalStyle from './globalStyle';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

const spacingInRems = (factor = 1) => {
  return `${Math.round(MuiTheme.spacing(factor) * 0.1 * 10) / 10}rem`;
};

const modifiedTheme = { ...MuiTheme, spacingInRems };

const ThemeProvider = ({ children }) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <CssBaseline />
      <StyledEngineProvider injectFirst>
        <StyledThemeProvider theme={modifiedTheme}>
          <MuiThemeProvider theme={modifiedTheme}>
            <GlobalStyle />
            {children}
          </MuiThemeProvider>
        </StyledThemeProvider>
      </StyledEngineProvider>
    </LocalizationProvider>
  );
};

ThemeProvider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired
};

export default ThemeProvider;
